import GeneralNotificationContainer from './GeneralNotificationContainer';

export { GeneralNotificationContainer };
